module.exports = __webpack_public_path__ + "static/allerta_rossa-034f752daaa66cbf06a6e5c740638a11.png";